var ActionType = /* @__PURE__ */ ((ActionType2) => {
  ActionType2["setIsInitialized"] = "setIsInitialized";
  ActionType2["setDeliveryLocationState"] = "setDeliveryLocationState";
  ActionType2["setWcMemberState"] = "setWcMemberState";
  ActionType2["setUserLocation"] = " setUserLocation";
  ActionType2["setSelectedWarehouse"] = "setSelectedWarehouse";
  ActionType2["setUserPreferences"] = "setUserPreferences";
  ActionType2["setCriteoUserCookie"] = "setCriteoUserCookie";
  ActionType2["setThirdPartyInfo"] = "setThirdPartyInfo";
  ActionType2["setWcCartOrder"] = "setWcCartOrder";
  ActionType2["setMiniBannerDetails"] = "setMiniBannerDetails";
  ActionType2["setStwInfo"] = "setStwInfo";
  return ActionType2;
})(ActionType || {});
export {
  ActionType
};
